<app-page-header
  title="Admin Dashboard"
  subtitle="Verwalte Benutzer, Einstellungen und System"
  icon="admin_panel_settings"
  variant="gradient">
</app-page-header>

<!-- nlc-style Content Grid -->
<div class="nlc-container nlc-slide-up">
  <div class="nlc-admin-grid">
    <!-- Pending Customers Card -->
    <div class="admin-grid-item">
      <div class="nlc-card register-content-header">
        <div class="register-content">
          <mat-icon class="card-icon pending-icon">pending_actions</mat-icon>
          <span class="nlc-heading-4">Registrierungen</span>
        </div>
        <div class="register-content">
          <p class="card-description">
            Kunden, die über Einladungslinks registriert wurden und auf Freischaltung warten.
          </p>
        </div>
        <div class="register-content">
          <button mat-raised-button routerLink="/admin/pending-customers" color="primary" class="card-button">
            <mat-icon>arrow_forward</mat-icon>
            Ansehen
          </button>
        </div>
      </div>
    </div>

    <div class="admin-grid-item">
      <app-admin-tools></app-admin-tools>
    </div>

    <!-- <div class="admin-grid-item">
      <app-ratings-widget></app-ratings-widget>
    </div> -->

  </div>
</div>
